import { render, staticRenderFns } from "./rolegroup-list.vue?vue&type=template&id=2cdaf166&"
import script from "./rolegroup-list.vue?vue&type=script&lang=js&"
export * from "./rolegroup-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cdaf166')) {
      api.createRecord('2cdaf166', component.options)
    } else {
      api.reload('2cdaf166', component.options)
    }
    module.hot.accept("./rolegroup-list.vue?vue&type=template&id=2cdaf166&", function () {
      api.rerender('2cdaf166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/usermgmt/rolegroup-list.vue"
export default component.exports